// extracted by mini-css-extract-plugin
export default {"container":"M9OBT0HgGj61PVqusSk8","body":"CAicsBcp8Rh_5DGdxpRu","header":"wedmL3FhYXmyMzaqMuj_","subHeader":"a5laQl982ezomdL1_YbN"};